const Leaflet = L;

const map = {
	init() {
		$.ajax({
			url: 'geo.json',
			dataType: 'json',
			success: this.onMarkersLoaded.bind(this)
		});
	},

	onMarkersLoaded(markers) {
		this.markers = markers
		const mapLeaflet = this.createMapLeaflet();
		this.addMarkers(mapLeaflet);
	},

	createMapLeaflet() {
		const mapLeaflet = Leaflet.map('map', {
			attributionControl: false,
			zoomControl: false,
			gestureHandling: true,
		});

		Leaflet.tileLayer('https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png?key=cb1_2c37_1_39023e5f2b1a1741eba5d871').addTo(mapLeaflet);

		// Move zoom control to bottom left
		Leaflet.control.zoom({ position: 'bottomleft' }).addTo(mapLeaflet)

		// Focus map on markers
		mapLeaflet.fitBounds(
			[ this.markers.map(m => [ m.lat, m.lng ]) ],
			{
				padding: [50, 50],
				maxZoom: 3
			}
		);

		return mapLeaflet;
	},

	addMarkers(mapLeaflet) {
		const redIcon = new Leaflet.Icon({
			iconUrl: 'assets/images/marker.png',
			iconSize: [25, 41],
			iconAnchor: [12, 41],
			popupAnchor: [1, -34],
		});

		this.markers.forEach((marker, i) => {
			Leaflet.marker([marker.lat, marker.lng], {
				icon: redIcon,
				zIndexOffset: this.markers.length - i
			}).addTo(mapLeaflet).bindPopup(`
				<span class="leaflet-popup-title-container">
			      <strong class="leaflet-popup-title">${marker.label}</strong>
			      <span class="leaflet-popup-description">${marker.description}</span>
			    </span>`
			);
		})
	}
}

map.init();
